module.exports = __webpack_public_path__ + "static/media/nova_sst.39bba263.png";